import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

/** Utilities */
import { authentication } from "../../app/slice/authSlice";
import { createCookie, removeCookie } from "../../utils/Cookies/CookieHandler";

/** Common Components */
import Image from "../../components/image/Image";
import Buttons from "../../components/ui/button/Buttons";
import Input from "../../components/ui/inputs/input/Input";

/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

/** RTK Query */
import { useAuthVerifyOTPMutation } from "../../app/services/authAPI";

/** CSS Files */
import "./TwoFactorAuthentication.scss";
import LoginForm from "../../features/login/Component/login";

const TwoFactorAuthentication = () => {
  const inputRef = useRef();

  const dispath = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location, "v,,");

  const { error } = SwalAlert();

  let rememberMe = location?.state?.rememberMe;
  let userEmail = location?.state?.user?.emailAddress;
  let lUserKey = location?.state?.user?.userID;
  let UserName = location?.state?.user?.userName;

  const [actualOtp, setActualOtp] = useState("");

  const [authVerifyOTP, {
    isLoading: isAuthVerifyOTPAdding,
    isSuccess: isAuthVerifyOTPAdded,
    data: authVerifyOTPData,
  },] = useAuthVerifyOTPMutation();

  const handleChange = (e) => {
    let value = e.target.value;
    setActualOtp(value)
  }

  const handleSubmitClick = () => {
    let requestOtp = actualOtp
    if (requestOtp && requestOtp.length === 6) {
      const req = {
        otp: requestOtp,
        emailAddress: userEmail,
        userID: lUserKey,
        UserName: UserName
      };

      authVerifyOTP(req);
    }
  };

  useEffect(() => {
    if (isAuthVerifyOTPAdded && authVerifyOTPData) {
      if (authVerifyOTPData?.isAuthenticated) {
        dispath(authentication(authVerifyOTPData));

        if (rememberMe) {
          const rememberMeCookie = {
            cookieName: "rememberMe",
            cookieValue: userEmail,
            path: "/",
            expirationTime: 7 * 24,
          };
          createCookie(rememberMeCookie);
        } else {
          removeCookie("rememberMe");
        }
        if (authVerifyOTPData?.user?.bPasswordResetRequired) {
          navigate(`/ResetPassword`);
        } else {
          navigate(`/Employer`);
        }
        ToastService.success("OTP Verified Successfully!");
      } else {
        error("", "Invalid OTP or OTP expired. Login again").then(
          (confirmed) => {
            if (confirmed) {
              removeCookie("rememberMe");
              navigate(`/login`);
            }
          }
        );
        removeCookie("rememberMe");
        navigate(`/login`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthVerifyOTPAdded, authVerifyOTPData]);

  return (
    <>
      {/* <div className="login-page two-factor-authentication">
      <div className="logo-sec">


        <div className="login-form">
          <div className="form">
            <div className="center-icon">
            <Image imagePath={AppIcons.logoImage} altText="Login Vector" />

            </div>
            <div className="title-sec">
              <h1 className="title">Two-Factor Authentication</h1>
              <p className="welcome-txt">
                Please Enter Authentication Code
              </p>
            </div>

            <div className="field mb-4">
            <Input
                  ref={inputRef}
                  maxLength={6}
                  placeholder="Authentication Code"
                  onChange={handleChange}
                  type="password" />
            </div>
            <div className="btn-sec">
            <Buttons
                  buttonText="Submit"
                  buttonTypeClassName="btn blue-btn w-full"
                  onClick={handleSubmitClick}
                  isLoading={isAuthVerifyOTPAdding}
                  isDisable={actualOtp.length < 6}
                />
            </div>
          </div>
        </div>
      </div>
    </div> */}

      <div className="main-page-layout login-main-section otp-page">
        <div className="container">
          {/* Login Section Start */}
          <div className="col-md-12 col-12">
            <div className="login-header-section">
              <Image imagePath={AppIcons.logoImage} altText="Logo" />
            </div>
          </div>
        </div>
        <div className="bottom-dark-desc-sections">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="title-desc-sec">
                  <h1 className="main-title">
                    Welcome to <span>LDC</span>
                  </h1>
                  {/* <div className="sub-title">Lorem Ipsum is simply</div> */}
                  <p>
                    The mission of the Laborers District Council of the
                    Metropolitan Area of Philadelphia and Vicinity is to assist
                    its membership in securing employment, to defend their
                    rights and advance their interests as working men and women,
                    and by education and co-operation, raise them to that
                    position in society to which they are justly entitled.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="sign-in-right-section">
                  <div className="sign-in-form-sec">
                    <div className="client-logo">
                      <Image imagePath={AppIcons.clientLogo} altText="Logo" />
                    </div>
                    <div className="form-title">Two-Factor Authentication</div>
                    <p className="pera">Please Enter Authentication Code</p>
                    <div className="signin-form-part">
                      <form>
                        <div className="row">
                          <Input
                            ref={inputRef}
                            maxLength={6}
                            placeholder="Authentication Code"
                            onChange={handleChange}
                            type="password" />
                        </div>
                      </form>
                      {/* <a className="forgot-pass-link" href="#change">
                Reset Your Password ?
            </a> */}
                      <div className="button-part">
                        <Buttons
                          buttonText="Submit"
                          buttonTypeClassName="btn success-btn"
                          onClick={handleSubmitClick}
                          isLoading={isAuthVerifyOTPAdding}
                          isDisable={actualOtp.length < 6}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>


  );
};

export default TwoFactorAuthentication;